var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionLeftRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 127,
    viewBox: "0 0 118 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.746 6.95132C116.01 17.1276 115.777 36.369 117.055 53.0533C118.197 67.962 117.058 82.6264 109.533 95.5588C101.034 110.165 90.1035 126.385 73.319 128.216C56.8123 130.018 45.0639 114.248 31.9996 104.018C19.6735 94.3671 2.81959 86.9231 0.746025 71.3925C-1.31183 55.9796 12.6731 44.2004 22.3902 32.0454C31.4412 20.7236 40.2233 9.03173 54.0513 4.71343C70.184 -0.324578 89.3513 -3.32597 102.746 6.95132Z",
    fill: "#B2D7F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionLeftRock);
export default __webpack_public_path__ + "static/media/heroSectionLeftRock.3751edd2806ec2ec86b307703b576b7c.svg";
export { ForwardRef as ReactComponent };